import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/** A seat at the table: face down until the cards are revealed. */
export function PlayerCard({
  name,
  hasVoted,
  vote,
  revealed,
  isMe,
  away,
}: {
  name: string;
  hasVoted: boolean;
  /** Only known once revealed (or for your own card). */
  vote: string | undefined;
  revealed: boolean;
  isMe: boolean;
  /** Left the room (shown dimmed while their vote still counts). */
  away: boolean;
}) {
  const faceUp = revealed && hasVoted;
  return (
    <div
      className={cn("flex flex-col items-center gap-2", away && "opacity-50")}
      data-testid="player"
      data-voted={hasVoted}
    >
      <div
        className={cn(
          "flex h-20 w-14 items-center justify-center rounded-lg text-sm font-bold transition-all",
          !hasVoted && "border border-border/50 bg-muted",
          hasVoted &&
            !revealed &&
            "border-2 border-primary bg-primary/20 shadow-lg shadow-primary/20",
          faceUp && "card-flip border-2 border-primary bg-primary text-primary-foreground",
        )}
      >
        {faceUp ? (
          <span className="text-lg" data-testid="player-vote">
            {vote ?? "?"}
          </span>
        ) : hasVoted ? (
          <Check className="size-4 text-primary" aria-label="Voted" />
        ) : (
          <span className="text-xs text-muted-foreground" aria-label="Not voted yet">
            —
          </span>
        )}
      </div>
      <span className={cn("max-w-20 truncate text-xs font-medium", isMe && "text-primary")}>
        {name}
        {isMe ? " (you)" : ""}
      </span>
    </div>
  );
}
